import { render, staticRenderFns } from "./SectionInfo.vue?vue&type=template&id=5a6070c6&"
import script from "./SectionInfo.vue?vue&type=script&lang=ts&"
export * from "./SectionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports